import * as moment from 'moment';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/Service/Common.service';
import { MapRoleFeatureService } from 'src/app/Service/map-role-feature/map-role-feature.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { WorkflowTemplateService } from 'src/app/Service/workflow-template/workflow-template.service';
import { BusinessGroupModel } from 'src/app/ViewModel/BusinessGroupModel';
import { EIPAutoCompleteEventModel } from 'src/app/ViewModel/EIPAutoCompleteEventModel';
import { RoleFeatureModel } from 'src/app/ViewModel/RoleFeatureModel';
import { WorkflowTemplateModel } from 'src/app/ViewModel/WorkflowTemplateModel';
import { AddWorkflowTemplateDialogComponent } from '../dialogs/add-workflow-template-dialog/add-workflow-template-dialog.component';
import { ProjectViewModel } from 'src/app/ViewModel/ProjectModel';
import { ProjectInfoService } from 'src/app/Service/project-info/project-info.service';

@Component({
	selector: 'app-workflow-template',
	templateUrl: './workflow-template.component.html',
	styleUrls: ['./workflow-template.component.css']
})
export class WorkflowTemplateComponent implements OnInit {

	enableFilter = false;
	enableFullscreen = false;

	workflowTemplateList: WorkflowTemplateModel[] = [];

	projectList: ProjectViewModel[] = [];
	businessGroupList: BusinessGroupModel[] = [];
	buList: RoleFeatureModel[] = [];
	icList: RoleFeatureModel[] = [];

	buid!: null | number;
	icid!: null | number;
	projectId!: null | number;
	businessGroupId!: null | number;
	workflowId!: null | number;

	icIsDisabled: boolean = false;
	projectIsDisabled: boolean = false;

	// clear EIPAutocomplete selected values
	clearIcSelected = 'N';
	clearBuSelected = 'N';
	clearProjectSelected = 'N';
	clearBusinessGroupSelected = 'N';

	constructor(
		private dialog: MatDialog,
		public commonService: CommonService,
		public notificationService: NotificationService,
		public mapRoleFeatureService: MapRoleFeatureService,
		public workflowTemplateService: WorkflowTemplateService,
		public projectInfoService: ProjectInfoService) { }

	ngOnInit() {
		this.getIcList();
		this.getBuList();
		this.getProject();
		this.getBusinessGroup(null);
		//this.getWorkflowTemplateList();
	}

	toggleFilter() {
		this.enableFilter = !this.enableFilter;
	}

	toggleFullscreen() {
		this.enableFullscreen = !this.enableFullscreen;
	}

	/**
	* Get business group list
	* @param projectId 
	*/
	async getBusinessGroup(projectId: number | null | undefined) {
		if (!projectId) {
			this.businessGroupList = [];
			return;
		}

		this.mapRoleFeatureService.getBusinessGroups(projectId).subscribe((data) => {
			this.businessGroupList = data.filter(each => each.is_Active);
		});
	}

	/**
	 * Get Project List
	 */
	async getProject() {
		this.projectInfoService.getProjectList(this.commonService.getLoggedInUserId()).subscribe((data: ProjectViewModel[]) => {
			if (data) {
				data.forEach(x => { x.projectDescription = x.projectCode + ' - ' + x.projectDescription });
			}
			this.projectList = data;
		});
	}

	/**
	 * Get BU List
	 */
	async getBuList() {
		if (!this.icid) {
			this.buList = [];
			return;
		}

		this.buList = await this.mapRoleFeatureService.getCommonDedAgainstDe(null, "BU").toPromise();
	}

	/**
	 * Get IC List
	 */
	async getIcList() {
		this.icList = await this.mapRoleFeatureService.getCommonDedAgainstDe(null, "IC").toPromise();
	}

	/**
	 * Get workflow template list
	 * Kendo data
	 */
	getWorkflowTemplateList() {
		if (!this.icid && !this.buid && !this.projectId && !this.businessGroupId && !this.workflowId) {
			this.workflowTemplateList = [];
			return
		}

		this.workflowTemplateService.getWorkflowTemplateList(this.icid, this.buid, this.projectId, this.businessGroupId, this.workflowId).subscribe(data => {
			this.workflowTemplateList = data;
		});
	}

	changeIc(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.icIsDisabled = false;
			this.projectIsDisabled = true;
		}
		else {
			this.icIsDisabled = false;
			this.projectIsDisabled = false;
		}

		this.buid = this.projectId = this.businessGroupId = null;
		this.icid = event.value != '-2' ? Number(event.value) : null;

		this.getBuList();
		this.getWorkflowTemplateList();
	}

	changeBu(event: EIPAutoCompleteEventModel<RoleFeatureModel>) {
		if (event.value != '-2') {
			this.projectId = this.businessGroupId = null;
		}

		this.buid = event.value != '-2' ? Number(event.value) : null;

		this.getWorkflowTemplateList();
	}

	changeProject(event: EIPAutoCompleteEventModel<ProjectViewModel>) {
		if (event.value != '-2') {
			this.icIsDisabled = true;
			this.projectIsDisabled = false;
		}
		else {
			this.icIsDisabled = false;
			this.projectIsDisabled = false;
		}

		this.icid = this.buid = this.businessGroupId = null;
		this.projectId = event.value != '-2' ? Number(event.value) : null;

		this.getBusinessGroup(this.projectId);
		this.getWorkflowTemplateList();
	}

	changeBusinessGroup(event: EIPAutoCompleteEventModel<BusinessGroupModel>) {
		if (event.value != '-2') {
			this.icid = this.buid = null;
		}

		this.businessGroupId = event.value != '-2' ? Number(event.value) : null;

		this.getWorkflowTemplateList();
	}

	openAddTemplateDialog(isCreateMode: boolean, dataItem: any, isViewMode?: boolean, modeName?: string) {
		this.workflowTemplateService.isViewMode = modeName == 'V' ? true : false;
		this.workflowTemplateService.isEditMode = modeName == 'E' ? true : false;
		this.workflowTemplateService.isCopyMode = false;
		let dialogRef = this.dialog.open(AddWorkflowTemplateDialogComponent, {
			disableClose: true,
			panelClass: 'mat-dialog-primary',
			data: {
				'workflowTemplateList': this.workflowTemplateList,
				'icList': this.icList,
				'buList': this.buList,
				'projectList': this.projectList,
				'businessGroupList': this.businessGroupList,
				'SrcProject': this.projectId,
				'SrcBG': this.businessGroupId,
				isCreateMode: modeName == 'C',
				isEditMode: modeName == 'E',
				isViewMode: modeName == 'V',
				dataItem,
			},
		});

		dialogRef.afterClosed().subscribe((data: any) => {
			this.getWorkflowTemplateList();
		});
	}

	/**
	 * Clear selected values in header EIP Auto complete
	 * Reset icon handler
	 */
	clearSelectedFilter() {
		this.clearIcSelected = this.clearBuSelected = this.clearProjectSelected = this.clearBusinessGroupSelected = 'Y';
		this.icid = this.buid = this.projectId = this.businessGroupId = null;
		this.icIsDisabled = this.projectIsDisabled = false;
		this.workflowTemplateList = [];
	}

	deleteWorkflowRow(dataItem: WorkflowTemplateModel) {
		this.notificationService.showPopup('Are you sure to delete Workflow template?', 'Confirm').then((data: any) => {
			if (data == 'yes') {
				this.workflowTemplateService.deleteWorkflowTemplate(dataItem.workflowId).subscribe(data => {
					if (data['successCode'] == 0) {
						this.notificationService.showToast("Workflow template deleted successfully", 'Success');
						this.getWorkflowTemplateList();
					}
				});
			}
		});
	}

}
